import type { FunctionComponent } from "react";
import { Link, Typography } from "@mui/material";
import { PACKAGE_VERSION } from "../utilities/constants";

const Footer: FunctionComponent = () => {
  return (
    <footer
      id="footer"
      style={{
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Link
        href="https://www.nextologies.com/vcc-services.html"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          alt="AirFirst logo"
          src="/img/vcc_nextologies.png"
          style={{
            height: "4.5dvh",
            width: "auto",
          }}
        />
      </Link>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Typography variant="caption">{`v${PACKAGE_VERSION}`}</Typography>
    </footer>
  );
};

export default Footer;
